module.exports = __webpack_public_path__ + "img/explain_radio_white.72fec338.svg";